import Service from '@ember/service';
import classic from 'ember-classic-decorator';

@classic
export default class MixpanelService extends Service {
  initialized = false;

  track(_eventName, _properties = {}, _options = null) {
    // noop - cleanup in progress
  }

  trackAnonymously(_eventName, _properties = {}) {
    // noop - cleanup in progress
  }

  trackWidgetClosed(_eventType, _properties) {
    // noop - cleanup in progress
  }
}
